var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlay = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 11,
  height: 13,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M1.699.72a1 1 0 0 0-1.537.844V11.92a1 1 0 0 0 1.537.843l8.137-5.178a1 1 0 0 0 0-1.687z"
})));
export { SvgPlay as ReactComponent };
export default "/_next/static/images/play.svg";